import React from 'react'

const ChatResponse = ({
  message = "👋 I'm Dante.",
  className = '',
  responseBackground = '',
  isInHumanHandoverApp = false,
  ...props
}) => {
  return (
    <div
      className={`
        bubble-chat-response
        inline-block
        max-w-full
        px-v3-sm
        py-[12px]
        rounded-v3-xl
        text-v3-h7
        ${!responseBackground ? 'bg-v3-black-card' : ''}
        ${isInHumanHandoverApp ? 'bg-v3-black-card' : ''}
        text-[var(--dt-color-element-100)]
        ${className}
      `}
      style={{
        ...(responseBackground && !isInHumanHandoverApp && { backgroundColor: responseBackground })
      }}
      {...props}
    >
      <div className="bubble-chat-text text-v3-h7 [&>p:not(:last-child)]:mb-3 break-words"
      style={{overflowWrap: 'anywhere'}}>{message}</div>
    </div>
  )
}

export default ChatResponse